import {Component, NgZone, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToasterService} from "angular2-toaster";

import {LoanService} from '../../shared-component/service/loan/loan.service';
import {ICustomWindow, WindowRefService} from '../terms-of-service/window.service';
import {environment} from '../../../environments/environment';
import {UtilService} from '../../util/util.service';
import {applicationStatus} from '../../shared-component/compare/compare.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-enach',
  templateUrl: './enach.component.html',
  styleUrls: ['./enach.component.css']
})
export class EnachComponent implements OnInit {

  public bankForm : FormGroup;
  public tokenId: string;
  public customerId: string;
  public showPage: boolean = false;
  public nupay: boolean = false;
  public loanDetail: any = {};
  public emiDetail: any = {};
  public advanceAmount: any = {};
  public showEnachProcess: boolean = false;
  public bankList: any = [];
  public crd: any = {};
  private _window: ICustomWindow;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private zone: NgZone,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private loanService: LoanService,
    private winRef: WindowRefService,
    private utilService: UtilService,
    private toasterService: ToasterService
  ) {
  }

  ngOnInit() {
    this.utilService.getCurrentPosition(this);
    
    this.activeRoute.data.subscribe((res: any) => {
      this.loanDetail = res.loanDetail;
      this.showEnachProcess = this.loanDetail.initialPaymentAmount ? (this.loanDetail.applicationStatus == applicationStatus.PAYMENT_DONE ? true : false): true;
      this.tokenId = this.loanDetail.token;
      
      if(!this.showEnachProcess){
        this.loanService.payment(this.tokenId,{ paymentId : true }).subscribe((res : any) => {
          if(res.data.reload){
            window.location.reload();
          }
        });
      } else {
        this.updateENach({ eMandatePartner : this.loanDetail.eMandatePartner, 
                           customerId      : this.customerId });
      }

      if (this.loanDetail.Customer.DigioEkycRequest && this.loanDetail.Customer.DigioEkycRequest.eKycRequestId && this.loanDetail.organizationId == 2) {
        this.loanService.checkAvanseEkycStatus(this.loanDetail.token).subscribe((res: any) => {
          if (res.data.status == 'Approved') {
            this.toasterService.pop("Avanse KYC Process Completed." );
          }
        }, error => {
          this.toasterService.pop('error', '', error.message);
        });
      }
      
      if(this.loanDetail.applicationStatus != applicationStatus.PAYMENT_DONE && this.loanDetail.initialPaymentAmount == 0){
        this.loanService.skipPayment(this.tokenId).subscribe((res: any) => {
          window.location.reload();
        });
      } else {
        this.showPage = true;
        this.getPaymentSchedule(this.tokenId, this.loanDetail.applyInsurance);
      }
    });

    this.bankForm = this.fb.group({
      bank: ['', Validators.compose([Validators.required])],
      accountNumber: ['', Validators.compose([Validators.required, Validators.pattern(/^[0-9]{6,25}$/)])],
      beneficiaryName: ['', Validators.compose([Validators.required, Validators.pattern(/^[a-zA-Z ]{3,35}$/)])],
      ifsc: ['', Validators.compose([Validators.required, Validators.pattern(/([A-Z]{4}[0-9]{7})|([A-Z]{4}[0-9]{3}[A-Z][0-9]{3})$/)])],
      accountType: ['', Validators.compose([Validators.required])]
    });

    // creating new key:value pair inside existing object to avoid creating new public variable 
    this.loanDetail.finalProcessingFee = 0;
    if(this.loanDetail.initialPaymentAmount){
      this.loanDetail.finalProcessingFee = this.loanDetail.processingFee - (this.loanDetail.waiverProcessingFee === null ? 0 : this.loanDetail.waiverProcessingFee)
    }

    // creating new key:value pair inside existing object to avoid creating new public variable 
    this.loanDetail.finalAdvanceEMI = true;
    if(this.loanDetail.systemAdvanceEmi == this.loanDetail.waiverAdvanceToTCPL){
      this.loanDetail.finalAdvanceEMI = 0;
    }
    this._window = this.winRef.nativeWindow;
    this.getAdvanceAmount();
  }

  get bank(){
    return this.bankForm.get("bank");
  } 

  get accountNumber(){
    return this.bankForm.get("accountNumber");
  } 

  get beneficiaryName(){
    return this.bankForm.get("beneficiaryName");
  } 

  get ifsc(){
    return this.bankForm.get("ifsc");
  } 

  get accountType(){
    return this.bankForm.get("accountType");
  } 

  public rzp1: any;
  public options: any = {
    amount: 0,
    name: environment.COMPANY_NAME,
    description: environment.AUTH_PAYMENT_DESCRIPTION,
    recurring: 1,
    prefill: {
      name: '',
      email: ''
    },
    notes: {},
    theme: {
      color: '#3D3BEE'
    },
    handler: this.paymentResponseHandler.bind(this),
    modal: {
      ondismiss: (() => {
        this.onEmandateDismiss();
      })
    }
  };

  onEmandateDismiss = () => {
    this.zone.run(() => {
      this.showPage = true;
      this.router.navigateByUrl(`/loan/process/${this.tokenId}/enach`).then();
    });
  }

  getPaymentSchedule(tokenId: string, applyInsurance: boolean) {
    this.loanService.paymentSchedule(tokenId, applyInsurance).subscribe((res: any) => {
      this.emiDetail = res.data;
    });
  }

  getAdvanceAmount() {
    this.loanService.paymentSchedule(this.tokenId, this.loanDetail.applyInsurance).subscribe((res: any) => {
      this.advanceAmount = res.data;
      if(this.loanDetail.finalAdvanceEMI)
      this.loanDetail.finalAdvanceEMI = (this.advanceAmount.withInsurance ?
                this.advanceAmount.withInsurance.emiAmount*this.advanceAmount.withInsurance.systemAdvanceTenure :
                this.advanceAmount.advance.system.amount )
    });
  }

  public optionsForInitialPayment: any = {
    name: environment.COMPANY_NAME,
    description: environment.PAYMENT_PROCESSING_FEE_DESCRIPTION,
    amount: 0,
    prefill: {
      name: '',
      email: ''
    },
    notes: {},
    theme: {
      color: '#3D3BEE'
    },
    handler: this.paymentResponseHandlerForInitialPayment.bind(this),
    modal: {
      ondismiss: (() => {
        this.zone.run(() => {
          this.router.navigateByUrl(`/loan/process/${this.tokenId}/enach`);
        });
      })
    }
  };

  async initPay() {
    let details = this.crd.data; //await this.utilService.getDeviceDetails();
    let data : any = {
      customerId: this.customerId,
      ...details
    };
    this.loanService.getPaymentAmount(this.tokenId, data ).subscribe((res : any) => {
      if(res.data.orderId){
        this.optionsForInitialPayment.amount = res.data.amount;
        this.optionsForInitialPayment.order_id = res.data.orderId;
        this.optionsForInitialPayment.prefill.email = this.loanDetail.Customer.email;
        this.optionsForInitialPayment.prefill.name = this.loanDetail.Customer.fullName;
        this.optionsForInitialPayment.prefill.contact = this.loanDetail.Customer.mobile;
        this.optionsForInitialPayment.notes.applicationNumber = this.loanDetail.applicationNumber;
        this.optionsForInitialPayment.notes.type = 'Processing';
        this.optionsForInitialPayment.key = res.data.razorPayKey || environment.RAZOR_PAY_KEY;
        this.rzp1 = new this.winRef.nativeWindow['Razorpay'](this.optionsForInitialPayment);
        this.rzp1.open();
      } else {
        data.paymentId = true;
        this.loanService.payment(this.tokenId,data).subscribe(() => {
          window.location.reload();
        });
      }
    });
  }

  async paymentResponseHandlerForInitialPayment(response: any) {
    let details = this.crd.data;
    this.zone.run(() => {
      let data = {
        paymentId: response.razorpay_payment_id,
        ...details
      };
      this.loanService.payment(this.tokenId,data).subscribe(() => {
        window.location.reload();
      });
    });
  }

  async setup(mandateType){
    if(!this.crd.status){
      return false;
    }
    if (this.loanDetail.eMandatePartner == "DIGIO") {
      this.loanService.digioPaymentMeta(this.tokenId, mandateType).subscribe((res: any) => {
        var options = {
          environment: environment.DIGIO_ENVIRONMENT,
          callback: response => {
            if (response.error_code != undefined) {
              this.zone.run(() => {
                this.toasterService.pop('error', '', response.message);
                this.onEmandateDismiss();
              });
            } else {
              this.loanService.digioMandateStatus(this.tokenId).subscribe((res: any) => {
                this.paymentResponseHandler({ ...res.data, eMandatePartner: "DIGIO" });
              }, error => {
                this.toasterService.pop('error', '', error.message);
                this.onEmandateDismiss();
              });
            }
          },
          logo: "https://s3.amazonaws.com/techfino.static/logoTechFino.png", 
        };
        var digio = new this.winRef.nativeWindow['Digio'](options);
        digio.init();
        digio.submit(res.data.mandateId, this.loanDetail.Customer.mobile || this.loanDetail.Customer.email);
      });
    } else if( this.loanDetail.eMandatePartner == "NUPAY" ){
      let bankData = {
        bankId : this.bank.value,
        bankName : this.bankList.find( a => this.bank.value == a.id ).name,
        beneficiaryName : this.beneficiaryName.value,
        accountNumber : this.accountNumber.value,
        accountType : this.accountType.value,
        ifscCode : this.ifsc.value,
        eMandatePartner : "NUPAY"
      };
      
      this.loanService.nupayPaymentMeta(this.tokenId, bankData).subscribe((res : any) => {
        let oThat = this;
        if(res.data.url){
          this.showPage = false;
          let mandateUrl = res.data.url;

          // Set responsive popup dimensions based on the device's screen size
          const mediaQuery = window.matchMedia("(max-width: 600px)");
          const isMobile = mediaQuery.matches;
          const popupWidth = isMobile ? window.innerWidth * 0.9 : 500;
          const popupHeight = isMobile ? window.innerHeight * 0.8 : 600;
  
          // Calculate the position to center the popup on the screen
          const left = (window.innerWidth - popupWidth) / 2;
          const top = (window.innerHeight - popupHeight) / 2;
  
          // Prepare the popup options
          const popupOptions = `width=${popupWidth},height=${popupHeight},top=${top},left=${left},scrollbars=yes,resizable=yes`;
  
          // Store a reference to the popup window
          let win = window.open(mandateUrl, 'eMudraPopup', popupOptions);
  
          // Add a message event listener to catch messages from the popup
          win.addEventListener('message', (event) => {
            //console.log('Message from Popup:', event.data);
  
            if (event.data.status == 'success') {
              oThat.updateENach(event.data);
              oThat.showPage = true;
            }
          });
          var timer = setInterval(function() { 
            if(win.closed) {
                clearInterval(timer);
                oThat.updateENach({});
                oThat.showPage = true;
            }
          }, 1000);
        } else {
          this.toasterService.pop('error', '', res.message);
        }
      });
      return;
    } else {
      this.loanService.paymentMeta(this.tokenId).subscribe((res: any) => {
        this.options.customer_id = res.data.customerId;
        this.options.order_id = res.data.orderId;
        this.options.notes.applicationNumber = this.loanDetail.applicationNumber;
        this.options.notes.type = 'Enach';
        this.customerId = res.data.customerId;
        this.options.prefill = {
          name: this.loanDetail.Customer.fullName,
          email: this.loanDetail.Customer.email,
          contact: this.loanDetail.Customer.mobile,
          method: 'emandate'
        };
        this.options.key = res.data.razorPayKey || environment.RAZOR_PAY_KEY_ENACH;
        this.rzp1 = new this.winRef.nativeWindow['Razorpay'](this.options);
        this.rzp1.open();
      });
    }
    this.showPage = false;
  }

  async paymentResponseHandler(res: any) {
    this.zone.run(() => {
     this.updateENach({...res, customerId: this.customerId}, true);
    });
  }

  async updateENach(data, flag = false){
    let details = this.crd.data;
    let deviceData = {
      ...data,
      ...details
    };
    
    if(flag){
      this.loanService.eNach(this.tokenId, deviceData).subscribe(() => {
        this.router.navigateByUrl(`/loan/process/${this.tokenId}/termsOfService`, {replaceUrl: true}).then();
      });
    } else {
      this.loanService.captureAutoDebt(this.tokenId, deviceData).subscribe((res : any) => {
        if(res.data.reload == true){
          window.location.reload();
        }
      });
    }

  }

  skip() {
    this.loanService.skipEnach(this.tokenId).subscribe(() => {
      this.router.navigateByUrl(`/loan/process/${this.tokenId}/termsOfService`, {replaceUrl: true}).then();
    });
  }

  // openSkipEmandatePopup(content: any) {
  //   this.modalService.open(content, {backdrop: 'static', centered: true});
  // }

  setupNupay(){
    this.nupay = true;
    if(!this.bankList.length){
      this.loanService.getBankList(this.tokenId).subscribe(( res: any ) => {
        this.bankList = res.data.list.sort( (a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0) );
      });
    }
  }
}
